<template>
    <div class="pizarra">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="chart-wrapper">

            <div class="dates">
                <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" color="secondary"
                    offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="formData.monthDate" :label="'*' + $t('report.label.monthDate')"
                            color="secondary" :rules="monthDateRules" readonly v-bind="attrs" v-on="on" :clearable="!!formData.monthDate"></v-text-field>
                    </template>
                    <v-date-picker v-model="localmonthDate" color="primary" @change="handleMonthDateChange" type="month" :max="maxMonth"></v-date-picker>
                </v-menu>
    
                <v-btn 
                    rounded 
                    color="primary"
                    :disabled="!formData.monthDate"
                    @click="loadChartData()">
                    {{ $t('button.consult') }}
                </v-btn>
            </div>

            <!-- Gráfica W1 (Mañana) -->
            <div class="chart-container col-md-9 col-sm-12">
                <h2>{{ $t('label.chartMorning') }}</h2>
                <div v-if="hasDataW1">
                    <line-chart 
                        :chart-data="chartDataW1" 
                        :options="baseChartOptions"
                    />
                </div>
                <div v-else class="no-data-message">
                    <p>{{ $t('label.dataMorning') }}</p>
                </div>
            </div>

            <!-- Gráfica W2 (Tarde) -->
            <div class="chart-container col-md-9 col-sm-12">
                <h2>{{ $t('label.chartAfternoon') }}</h2>
                <div v-if="hasDataW2">
                    <line-chart 
                        :chart-data="chartDataW2" 
                        :options="baseChartOptions"
                    />
                </div>
                <div v-else class="no-data-message">
                    <p>{{ $t('label.dataAfternoon') }}</p>
                </div>
            </div>

            <div class="img-btn" >
                <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on" @click="sendEmailResults" :disabled="!formData.monthDate">
                    <v-icon dark>mdi-email</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('button.send') }}</span>
                </v-tooltip>
            </div>
        </div>
    </div>
</template>
  
<script>
import { Line } from 'vue-chartjs';

// Componente de gráfica de líneas personalizado
const LineChart = {
  extends: Line,
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
        this.renderChart(this.chartData, this.options)
      }
    }
  }
}

import {
    HAPPINESS_M,
    ACTION_GET_RESULTS_MONTHLY_CHART,
    ACTION_EMAIL_SEND_HAPINNES,
    GET_RESULTS_MONTHLY_CHART,
    GET_STATE_LOADING
} from "@/views/chart/store/types/types.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

export default {
    name: "monthlyLineChartComponent",
    components: {
        LineChart
    },
    data() {
        return {
            formData: {
                monthDate: null,
            },
            maxMonth: new Date().toISOString().slice(0, 7),
            monthDateRules: [
                v => !!v || this.$t('report.label.monthDate.required')
            ],
            menu1: false, // Para el date picker de fecha inicio
            localmonthDate: null,

            resultsMonthly: null,
            windowsData: {
                W1: {
                    labels: [],
                    datasets: []
                },
                W2: {
                    labels: [],
                    datasets: []
                }
            },
            baseChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        align: 'center',
                        labels: {
                            boxWidth: 15,
                            padding: 20,
                            color: '#333',
                            font: {
                                size: 12,
                                weight: '500'
                            },
                            usePointStyle: true
                        }
                    }
                },
                scales: {
                    y: {
                        display: true,
                        title: {
                            display: true,
                            color: '#2D0049',
                            font: {
                                size: 14,
                                weight: 'bold',
                                family: 'Arial, sans-serif'
                            },
                            padding: {
                                top: 10,
                                bottom: 10
                            }
                        },
                        beginAtZero: true,
                        grid: {
                            display: true,
                            color: '#e0e0e0',
                            borderDash: [2, 2]
                        },
                        ticks: {
                            color: '#666',
                            font: {
                                size: 11
                            }
                        }
                    },
                    x: {
                        display: true,
                        title: {
                            display: true,
                            color: '#2D0049',
                            font: {
                                size: 14,
                                weight: 'bold',
                                family: 'Arial, sans-serif'
                            },
                            padding: {
                                top: 10,
                                bottom: 5
                            }
                        },
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#666',
                            font: {
                                size: 11
                            }
                        }
                    }
                },
                elements: {
                    point: {
                        radius: 4,
                        hoverRadius: 6,
                        borderWidth: 2
                    },
                    line: {
                        tension: 0.4,
                        borderWidth: 3
                    }
                },
                interaction: {
                    intersect: false,
                    mode: 'index'
                },
                animation: {
                    duration: 1000,
                    easing: 'easeOutQuart'
                }
            },
        }
    },
    
    async mounted() {
        await this.loadChartData()
    },
    
    methods: {
        handleMonthDateChange(date) {
            const selectedDate = new Date(`${date}T00:00:00`);
            if (isNaN(selectedDate)) {
                console.error("Invalid date object:", date);
                return;
            }

            this.localmonthDate = date;
            const modifiedDate = new Date(selectedDate);
            this.formData.monthDate = date;
            this.validateMonthDate(modifiedDate);
            this.menu1 = false;
        },

        validateMonthDate(modifiedDate) {
            // Validar que la fecha no sea anterior a octubre de 2025
            const minDate = new Date('2025-10');
            const selectedDate = new Date(modifiedDate);
            
            if (selectedDate < minDate) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.date.invalid'),
                    text: i18n.t('label.startDate.invalid.text6')
                });
                this.localStartDate = null;
                this.formData.startDate = null;
                return;
            }

            const anioActual = new Date().getFullYear();
            const anioSeleccionado = modifiedDate.getFullYear();
            if (anioSeleccionado > anioActual) {
                Swal.fire({
                    icon: "error",
                    title: i18n.t('label.date.invalid'),
                    text: i18n.t('label.monthDate.invalid.text2')
                });
                this.localmonthDate = null;
                this.formData.monthDate = null;
                return;
            }
        },

        async loadChartData() {
            try {
                // Si no hay mes seleccionado, cargar el mes presente
                if (!this.formData.monthDate) {
                    const today = new Date();
                    const year = today.getFullYear();
                    const month = today.getMonth(); // 0 = enero, 11 = diciembre
                    
                    // Formatear como YYYY-MM (formato que usa v-date-picker type="month")
                    const currentMonth = `${year}-${String(month + 1).padStart(2, '0')}`;
                    
                    this.formData.monthDate = currentMonth;
                    this.localmonthDate = currentMonth;
                }
                this.resultsMonthly = await this.actionGetresultsMonthlyChart(this.formData)
                // Procesar datos del servicio
                this.processChartData()
            } catch (err) {
                console.error("Error cargando datos:", err)
            }
        },

        // Método para procesar datos dinámicos del servicio
        processChartData() {
            if (this.resultsMonthly && 
                this.resultsMonthly.data && 
                this.resultsMonthly.data.payload && 
                this.resultsMonthly.data.payload.windows) {
                const windows = this.resultsMonthly.data.payload.windows;
                // Procesar W1 (Mañana)
                if (windows.W1) {
                    this.windowsData.W1 = {
                        labels: windows.W1.labels || [],
                        datasets: windows.W1.datasets || []
                    };
                }
                
                // Procesar W2 (Tarde)
                if (windows.W2) {
                    this.windowsData.W2 = {
                        labels: windows.W2.labels || [],
                        datasets: windows.W2.datasets || []
                    };
                }
            }
        },

        // Obtener colores para cada dataset
        getDatasetColors(label) {
            const colorMap = {
                [i18n.t('label.chartHappiness')]: {
                    backgroundColor: 'rgba(28, 185, 16, 0.1)',
                    borderColor: '#1cb910',
                    pointBackgroundColor: '#1cb910'
                },
                [i18n.t('label.chartSadness')]: {
                    backgroundColor: 'rgba(185, 16, 16, 0.1)',
                    borderColor: '#b91010',
                    pointBackgroundColor: '#b91010'
                },
                [i18n.t('label.chartNeutral')]: {
                    backgroundColor: 'rgba(185, 181, 16, 0.1)',
                    borderColor: '#b9b510',
                    pointBackgroundColor: '#b9b510'
                }
            };
            
            return colorMap[label] || {
                backgroundColor: 'rgba(128, 128, 128, 0.1)',
                borderColor: '#b9b510',
                pointBackgroundColor: '#b9b510'
            };
        },

        // Método para verificar si hay datos válidos en un dataset
        hasValidData(windowData) {
            if (!windowData.labels || !windowData.datasets) {
                return false;
            }
            
            if (windowData.labels.length === 0 || windowData.datasets.length === 0) {
                return false;
            }
            
            // Verificar si al menos un dataset tiene datos válidos
            return windowData.datasets.some(dataset => 
                dataset.data && 
                dataset.data.length > 0 && 
                dataset.data.some(value => value !== null && value !== undefined && value !== 0)
            );
        },

        async sendEmailResults() {
            const result = await Swal.fire({
                icon: "info",
                title: i18n.t('report.label.sendEmailResults.title'),
                text: i18n.t('report.label.sendEmailResults.text') + ' ' + atob(sessionStorage.getItem('email')),
                showCancelButton: true,
                confirmButtonText: i18n.t('button.accept.text'),
                confirmButtonColor: '#6E17A5'
            });

            if (result.isConfirmed) {
                this.actionPostReportEmail(this.formData);
            }
        },

        ...mapActions({
            actionGetresultsMonthlyChart: `${HAPPINESS_M}${ACTION_GET_RESULTS_MONTHLY_CHART}`,
            actionPostReportEmail: `${HAPPINESS_M}${ACTION_EMAIL_SEND_HAPINNES}`,
        }),
    },
    
    computed: {
        // Verificar si W1 (Mañana) tiene datos
        hasDataW1() {
            return this.hasValidData(this.windowsData.W1);
        },

        // Verificar si W2 (Tarde) tiene datos
        hasDataW2() {
            return this.hasValidData(this.windowsData.W2);
        },

        // Datos de W1 (Mañana)
        chartDataW1() {
            const windowData = this.windowsData.W1;
            if (!windowData.labels.length || !windowData.datasets.length) {
                return { labels: [], datasets: [] };
            }
            
            const processedDatasets = windowData.datasets.map(dataset => {
                const colors = this.getDatasetColors(dataset.label);
                
                return {
                    label: dataset.label,
                    data: dataset.data,
                    backgroundColor: colors.backgroundColor,
                    borderColor: colors.borderColor,
                    pointBackgroundColor: colors.pointBackgroundColor,
                    pointBorderColor: '#ffffff',
                    fill: true
                };
            });
            
            return {
                labels: windowData.labels,
                datasets: processedDatasets
            };
        },

        // Datos de W2 (Tarde)
        chartDataW2() {
            const windowData = this.windowsData.W2;
            if (!windowData.labels.length || !windowData.datasets.length) {
                return { labels: [], datasets: [] };
            }
            
            const processedDatasets = windowData.datasets.map(dataset => {
                const colors = this.getDatasetColors(dataset.label);
                
                return {
                    label: dataset.label,
                    data: dataset.data,
                    backgroundColor: colors.backgroundColor,
                    borderColor: colors.borderColor,
                    pointBackgroundColor: colors.pointBackgroundColor,
                    pointBorderColor: '#ffffff',
                    fill: true
                };
            });
            
            return {
                labels: windowData.labels,
                datasets: processedDatasets
            };
        },

        ...mapGetters({
            resultsMonthlyChart: `${HAPPINESS_M}${GET_RESULTS_MONTHLY_CHART}`,
            loading: [`${HAPPINESS_M}${GET_STATE_LOADING}`],
        }),
    },
};
</script>
  
<style lang="css" scoped>
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Amsi Pro', sans-serif;
        color: #2D0049;
        font-weight: normal;
    }

    .dates {
        display: inline-flex;
        gap: 20px;
    }

    .chart-container {
        margin: auto;
        font-family: 'Arial', sans-serif;
        padding: 20px;
    }

    .chart-wrapper {
        position: relative;
        padding: 20px;
        text-align: center;
    }

    .no-data-message {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 200px;
    }

    .no-data-message p {
        font-size: 16px;
        color: #6c757d;
        margin: 0;
    }

    /* Responsive */
    @media (max-width: 600px) {        
        .chart-container {
            padding: 15px;
        }

        .chart-wrapper {
            padding: 10px;
        }

        .no-data-message p {
            font-size: 14px;
        }
    }
</style>